import {
  timeoutCall,
} from "@common";

import { createApiSlice } from "@common/common-slice/commonSlice";

import axios from "axios";

import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  CRUD_ASSESSORS_RESPONSE_LIST,
  DOWNLOAD_SKILLIQ_ASSESSMENT_REPORT,
  GET_SKILL_ASSESSMENT_ASSESSOR_BY_ID,
  GET_SKILLIQ_ASSESSMENT_ALL_TYPES_RESPONSE,
  GET_SKILLIQ_ASSESSMENT_BOOLEAN_RESPONSE,
  POST_REMAINDER_RESPONSE_LIST_SKILL_IQ,
  SEND_REMINDER_MAIL_SKILL_IQ
} from "@routes";

const apiConfig = [
  {
    name: "getSkillIQAssessmentAllQuestionTypesResponse",
    method: "get",
    url: GET_SKILLIQ_ASSESSMENT_ALL_TYPES_RESPONSE,
    stateKey: "skillIQAssessmentReportDataAll",
  },
  {
    name: "getSkillIQAssessmentBooleanQuestionTypesResponse",
    method: "get",
    url: GET_SKILLIQ_ASSESSMENT_BOOLEAN_RESPONSE,
    stateKey: "skillIQAssessmentReportDataBoolean",
  },
  {
    name: "postHistoryRemainderResponseListSkillIq",
    method: "post",
    url: POST_REMAINDER_RESPONSE_LIST_SKILL_IQ,
    stateKey: "remainderHistoryData",
  },
  {
    name: "getSkillAssessmentAssessorsById",
    method: "post",
    url: GET_SKILL_ASSESSMENT_ASSESSOR_BY_ID,
    stateKey: "assessorsResponseList",
  },
  {
    name: "sendReminderMailSkillIq",
    method: "post",
    url: SEND_REMINDER_MAIL_SKILL_IQ,
    stateKey: "message",
  },
  {
    name: "getAssessorsResponseList",
    method: "post",
    url: CRUD_ASSESSORS_RESPONSE_LIST,
    stateKey: "assessorsResponseList",
  },
];

export const downloadSkillIQAssessmentReport = createAsyncThunk(
  "assessmentResponse/downloadSkillIQAssessmentReport",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        DOWNLOAD_SKILLIQ_ASSESSMENT_REPORT,
        {
          params: {
            piedapUserId: data?.piedapUserId,
            skillAssessmentId: data?.skillAssessmentId,
          },
          withCredentials: true,
          responseType: "blob",
        },
      );

      // Check header first (in case backend exposes it later), otherwise fallback to the passed fileName
      let filename = data?.fileName || "AssessmentReport.xlsx";
      const disposition = response.headers?.["content-disposition"];

      if (disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .split(";")[0]
          .replaceAll(/['"]/g, "")
          .trim();
      }

      const url = globalThis.URL.createObjectURL(
        new Blob([response.data]),
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);

      document.body.appendChild(link);
      link.click();

      link.remove();
      globalThis.URL.revokeObjectURL(url);

      resetFunction(dispatch);

      return response;
    } catch (err) {
      resetFunction(dispatch);

      return rejectWithValue(err.response);
    }
  },
);
  
const customReducers = {
  initialState: {
    genLoading: false,

    assessmentResponseData: [],
    selfResponseData: [],
    assessorsResponseList: [],
    reportsData: [],
    optionalCommentsData: [],
    remainderHistoryData: [],
    shortResponseData: [],
    longResponseData: [],
    allAssessmentReportData: [],
    mcqData: {},
    mcqDataDetails: [],
    skillIQAssessmentReportDataAll: [],
    skillIQAssessmentReportDataBoolean: [],
    generatedSkillIQAnalysisReportData: [],
    analysisReportData: [],
    generatedAnalysisReportData: [],
    reportDetails: [],
    selectedData: {},
  },

  reducers: {
  },

  extraReducers: {
    "assessmentResponse/downloadSkillIQAssessmentReport/pending": (state) => {
      state.loading = true;
    },

    "assessmentResponse/downloadSkillIQAssessmentReport/fulfilled": (state) => {
      state.loading = false;
    },

    "assessmentResponse/downloadSkillIQAssessmentReport/rejected": (
      state,
      action,
    ) => {
      state.loading = false;

      state.errMessage = action?.payload?.message;
    },
  },
};

const { slice, thunks, actions } =
  createApiSlice(
    "assessmentResponse",
    apiConfig,
    customReducers,
  );

const assessmentResponseSlice = slice;

export default assessmentResponseSlice.reducer;

export const {
  getSkillIQAssessmentAllQuestionTypesResponse,
  getSkillIQAssessmentBooleanQuestionTypesResponse,
  getSkillAssessmentAssessorsById,
  postHistoryRemainderResponseListSkillIq,
  getAssessorsResponseList,
  sendReminderMailSkillIq
} = thunks;

export const {
  resetMessage,resetErrMessage
} = actions;

const resetFunction = (dispatch) => {
  timeoutCall(() => {
    dispatch(resetMessage());
    dispatch(resetErrMessage());
  });
};